import {strEnum} from "../../types";
import {TCITenantAppType} from "./tci-application";
import {ITCITenantRequest, ITCITenantResponse} from "./tci-tenant";

export const TCIExecHistoryStatus = strEnum(["COMPLETED", "CANCELLED", "FAULTED"]);
export type TCIExecHistoryStatus = keyof typeof TCIExecHistoryStatus;

export const TCIExecHistorySortableColumn = strEnum(["processInstanceState", "appnodeName", "processName", "processInstanceId", "processInstanceDurationTime", "processInstanceStartTime", "processInstanceEndTime"]);
export type TCIExecHistorySortableColumn = keyof typeof TCIExecHistorySortableColumn;

export class TCIExecHistoryStatusLabel {
    public static SUCCESS = new TCIExecHistoryStatusLabel(TCIExecHistoryStatus.COMPLETED, "Success");
    public static CANCELLED = new TCIExecHistoryStatusLabel(TCIExecHistoryStatus.CANCELLED, "Cancelled");
    public static FAILED = new TCIExecHistoryStatusLabel(TCIExecHistoryStatus.FAULTED, "Failed");

    private constructor(private status: string, private label: string) {
    }

    public static fromString(str: string): TCIExecHistoryStatusLabel {
        switch (str) {
            case TCIExecHistoryStatusLabel.SUCCESS.status:
                return TCIExecHistoryStatusLabel.SUCCESS;
            case TCIExecHistoryStatusLabel.CANCELLED.status:
                return TCIExecHistoryStatusLabel.CANCELLED;
            case TCIExecHistoryStatusLabel.FAILED.status:
                return TCIExecHistoryStatusLabel.FAILED;
        }
    }

    public static fromStatusToLabel(status: TCIExecHistoryStatus): string {
        switch (status) {
            case TCIExecHistoryStatus.COMPLETED:
                return TCIExecHistoryStatusLabel.SUCCESS.Label;
            case TCIExecHistoryStatus.CANCELLED:
                return TCIExecHistoryStatusLabel.CANCELLED.Label;
            case TCIExecHistoryStatus.FAULTED:
                return TCIExecHistoryStatusLabel.FAILED.Label;
        }
    }

    get Status(): string {
        return this.status;
    }

    get Label(): string {
        return this.label;
    }
}

export interface ITCIExecHistory {
    appType: TCITenantAppType;
    appId: string;
    applicationName: string;
    applicationVersion: string;
    moduleName: string;
    moduleVersion: string;
    componentProcessName: string;
    jobId: string;
    parentProcessName: string;
    parentProcessInstanceId: string;
    processName: string;
    processInstanceId: string;
    processInstanceStartTime: number;
    processInstanceEndTime: number;
    processInstanceDurationTime: number;
    processInstanceEvalTime: number;
    processInstanceState: TCIExecHistoryStatusLabel;
    domainName: string;
    appSpaceName: string;
    appNodeName: string;
    activityExecutionId: string;
}

export interface ITCIExecHistoryDetailActivity {
    activityInstanceUid: string;
    timestmp: number;
    applicationName: string;
    applicationVersion: string;
    moduleName: string;
    moduleVersion: string;
    processName: string;
    processInstanceId: string;
    activityName: string;
    activityStartTime: number;
    activityDurationTime: number;
    activityEvalTime: number;
    activityState: TCIExecHistoryStatusLabel;
    domainName: string;
    appSpaceName: string;
    appNodeName: string;
    activityInput: any[];
    activityOutput: any[];
    activityExecutionId: string;
}

export interface ITCIExecHistoryDetailTransition {
    transitionInstanceUid: string;
    timestmp: number;
    applicationName: string;
    applicationVersion: string;
    moduleName: string;
    moduleVersion: string;
    componentProcessName: string;
    processName: string;
    processInstanceId: string;
    transitionName: string;
    domainName: string;
    appSpaceName: string;
    appNodeName: string;
}

export interface ITCIExecHistoryDetail {
    activity: ITCIExecHistoryDetailActivity[];
    transition: ITCIExecHistoryDetailTransition[];
}

export interface ITCIExecHistoryFilterTimeRange {
    startTime?: number;
    endTime?: number;
}

export interface ITCIExecHistoryFilter extends ITCIExecHistoryFilterTimeRange {
    processName?: string;
    status?: TCIExecHistoryStatus | null;
    searchText?: string;
    sortColumn?: TCIExecHistorySortableColumn | null;
    sortDesc?: boolean;
}

export interface ITCIExecHistoryResponse extends ITCITenantResponse {
    result: ITCIExecHistory[];
    filter?: ITCIExecHistoryFilter;
    total?: number;
    page?: number;
    limit?: number;
}

export interface ITCIExecHistoryRequest extends ITCITenantRequest {
    /**
     * Application Id
     */
    appId: string;
    page: number;
    limit?: number;
    timeRange: ITCIExecHistoryFilterTimeRange;
}

// tslint:disable-next-line:no-empty-interface
export interface ITCIExecHistoryProcessResponse extends ITCIExecHistoryResponse {
}

export interface ITCIExecHistoryListPageOutput extends ITCIExecHistoryFilter {
    page?: number;
    limit?: number;
}

export interface ITCIExecHistoryProcessList {
    processName: string;
}
export interface ITCIExecHistoryProcessListResponse extends ITCITenantResponse {
    result: ITCIExecHistoryProcessList[];
}

export interface ITCIExecHistoryDetailRequest extends ITCITenantRequest {
    /**
     * Application Id
     */
    appId: string;
    processStartTime: number;
    processEndTime: number;
}
export interface ITCIExecHistoryDetailResponse extends ITCITenantResponse {
    result: ITCIExecHistoryDetail;
}

export interface ITCIExecHistoryFilterOption {
    key: string;
    label: string;
}
